import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentWebhook } from '../../../models/payment-webhook';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { GenericWebhook } from '../../../models/generic-webhook';

@Injectable({
  providedIn: 'root'
})
export class PaymentWebhookService {

  private baseUrl = environment.url;

  private http = inject(HttpClient)

  getPaymentWebhooksList = (): Observable<GenericWebhook<PaymentWebhook>> => {
    return this.http.get<GenericWebhook<PaymentWebhook>>(`${this.baseUrl}/webhooks/paymennt`);
  }

  addPaymentWebhook = (payload: object): Observable<PaymentWebhook> => {
    return this.http.post<PaymentWebhook>(`${this.baseUrl}/webhooks/paymennt`, payload);
  }

  deletePaymentWebhook = (paymentWebhookID: string): Observable<PaymentWebhook> => {
    return this.http.post<PaymentWebhook>(`${this.baseUrl}/webhooks/paymennt/${paymentWebhookID}/delete`, {})
  }

  enablePaymentWebhook = (paymentWebhookID: string): Observable<PaymentWebhook> => {
    return this.http.post<PaymentWebhook>(`${this.baseUrl}/webhooks/paymennt/${paymentWebhookID}/enable`, {})
  }

  disablePaymentWebhook = (paymentWebhookID: string): Observable<PaymentWebhook> => {
    return this.http.post<PaymentWebhook>(`${this.baseUrl}/webhooks/paymennt/${paymentWebhookID}/disable`, {})
  }

  testPaymentWebhook = (paymentWebhookID: string): Observable<PaymentWebhook> => {
    return this.http.post<PaymentWebhook>(`${this.baseUrl}/webhooks/paymennt/${paymentWebhookID}/test`, {})
  }
}
